/*
 * SMParts — Häufige Fragen.
 *
 * Das Auf- und Zuklappen macht der Browser. Dieses Skript tut nur
 * eines: dafuer sorgen, dass hoechstens eine Frage offen ist, wenn
 * die Section das verlangt. Ohne das Skript bleibt alles bedienbar,
 * dann lassen sich eben mehrere Fragen gleichzeitig oeffnen.
 */
(function () {
  'use strict';

  function einrichten(liste) {
    if (liste.dataset.smpFaqBereit) return;
    liste.dataset.smpFaqBereit = '1';

    liste.addEventListener('toggle', function (e) {
      var punkt = e.target;
      if (!punkt.open || punkt.tagName !== 'DETAILS') return;

      Array.prototype.forEach.call(liste.children, function (anderer) {
        if (anderer !== punkt && anderer.open) anderer.open = false;
      });
    }, true); /* toggle blubbert nicht — in der Erfassungsphase hoeren */
  }

  function alle() {
    document.querySelectorAll('[data-smp-faq-eine]').forEach(einrichten);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', alle);
  } else {
    alle();
  }

  /* Der Theme-Editor baut Sections neu auf. */
  document.addEventListener('shopify:section:load', alle);
})();
